import * as React from "react";
import { Form, Input, Select } from "antd";
import { FactFormFields } from "../../../common/Constants";
import { IFact } from "../../../model/evaluation/Fact";
import TextArea from "antd/lib/input/TextArea";

const FactForm = ({
  getFieldDecorator,
  translate,
  codebooks,
  rowData
}: {
  getFieldDecorator: any;
  translate: any;
  rowData?: IFact;
  codebooks: { factDataTypes: Array<{ id: string; name: string }> };
}) => {
  return (
    <Form>
      <Form.Item label={translate("fact_form.name")}>
        {getFieldDecorator(FactFormFields.Fields.NAME, {
          initialValue: rowData && rowData.name,
          rules: [
            {
              required: true,
              message: translate("fact_form.required_messages", {
                field: translate("fact_form.name")
              })
            }
          ]
        })(<Input />)}
      </Form.Item>
      <Form.Item label={translate("fact_form.description")}>
        {getFieldDecorator(FactFormFields.Fields.DESCRIPTION, {
          initialValue: rowData && rowData.description,
          rules: [
            {
              required: true,
              message: translate("fact_form.required_messages", {
                field: translate("fact_form.description")
              })
            }
          ]
        })(<Input />)}
      </Form.Item>
      <Form.Item label={translate("fact_form.dataType")}>
        {getFieldDecorator(FactFormFields.Fields.DATATYPE, {
          initialValue: rowData && rowData.dataType,
          rules: [
            {
              required: true,
              message: translate("fact_form.required_messages", {
                field: translate("fact_form.dataType")
              })
            }
          ]
        })(
          <Select
            placeholder={translate("fact_form.select_datatype")}
            allowClear
            showSearch={true}
            notFoundContent={translate("search.no_data")}
          >
            {codebooks.factDataTypes.map(item => (
              <Select.Option key={item.id}>
                {translate(`fact_form.data_type_${item.name.toLowerCase()}`)}
              </Select.Option>
            ))}
          </Select>
        )}
      </Form.Item>
      <Form.Item label={translate("fact_form.sqlExpression")}>
        {getFieldDecorator(FactFormFields.Fields.SQLEXPRESSION, {
          initialValue: rowData && rowData.sqlExpression,
          rules: [
            {
              required: true,
              message: translate("fact_form.required_messages", {
                field: translate("fact_form.sqlExpression")
              })
            }
          ]
        })(<TextArea rows={8} />)}
      </Form.Item>
    </Form>
  );
};

export default FactForm;
